import { useState, useEffect } from 'react';

const DEV_AUTH_USER = import.meta.env.VITE_DEV_AUTH_USER || 'dev';
const DEV_AUTH_PASS = import.meta.env.VITE_DEV_AUTH_PASS || 'password';
const SESSION_KEY = 'dev-authenticated';

const DevAuthWrapper = ({ children }) => {
    // Using Vite's import.meta.env for environment variables
    const isDev = import.meta.env.VITE_APP_ENV === 'DEV';

    // We check session storage directly. If not dev, this component won't render the form anyway.
    const [isAuthenticated, setIsAuthenticated] = useState(sessionStorage.getItem(SESSION_KEY) === 'true');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isDev) {
            const authStatus = sessionStorage.getItem(SESSION_KEY) === 'true';
            setIsAuthenticated(authStatus);
        }
    }, [isDev]);

    // If it's not a dev environment, just render the children.
    if (!isDev) {
        return <>{children}</>;
    }

    const handleLogin = (e) => {
        e.preventDefault();
        if (username === DEV_AUTH_USER && password === DEV_AUTH_PASS) {
            sessionStorage.setItem(SESSION_KEY, 'true');
            setIsAuthenticated(true);
            setError('');
        } else {
            setError('Invalid credentials. Please try again.');
        }
    };

    // If authenticated in dev, render the children.
    if (isAuthenticated) {
        return <>{children}</>;
    }

    // Otherwise, show the dev login form.
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' }}>
            <div style={{ padding: '40px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', backgroundColor: 'white', textAlign: 'center' }}>
                <h2 style={{ marginBottom: '24px' }}>Login</h2>
                <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '300px' }}>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Username"
                        style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
                    />
                    {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}
                    <button type="submit" style={{ padding: '10px', borderRadius: '4px', border: 'none', backgroundColor: '#007bff', color: 'white', cursor: 'pointer' }}>
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default DevAuthWrapper;